<template>
  <b-collapse id="main-menu-flyout" v-model="showCollapse" class="w-100 d-md-none">
    <div class="py-3">
      <ul class="col-12 list-unstyled font-condensed m-0">
        <template v-for="(item, i) in menuitems">
          <li v-if="!item.items"
              :key="'main-menu-mobile-item_' + i"
              class="nav-item text-uppercase"
              :class="{ 'mt-2': i > 0 }"
              :data-test-id="'main-menu-mobile-item_' + i"
          >
            <a class="nav-link p-3"
               :class="{ 'active': item === activeMenuItem, 'disabled': item.disabled }"
               :href="item.disabled ? undefined : item.path"
               :aria-disabled="item.disabled || undefined"
            >
              <b-icon v-if="item.icon && item.icon !== 'null'" :icon="item.icon" fixed-width />
              <span class="ms-2 text-uppercase">{{ item.title }}</span>
            </a>
          </li>

          <li v-else
                      :key="'main-menu-mobile-item_' + i"
                      v-b-toggle="'main-menu-mobile-subnav_' + i"
                      class="position-relative w-100 nav-link text-uppercase p-3 cursor-pointer"
                      :data-test-id="'main-menu-mobile-item_' + i"
                      :class="{ 'mt-2': i > 0, 'active': item === activeMenuItem }"
          >
            <b-icon v-if="item.icon && item.icon !== 'null'" :icon="item.icon" fixed-width />
            <span class="ms-2 text-uppercase dropdown">
              {{ item.title }}
              <span class="float-end dropdown-toggle" />
            </span>
          </li>

          <b-collapse v-if="item.items"
                      :id="'main-menu-mobile-subnav_' + i"
                      :key="'main-menu-mobile-subnav_' + i"
                      tag="ul"
                      class="subnavigation list-unstyled"
                      :data-test-id="'main-menu-mobile-subnav_' + i"
          >
            <li v-for="(s, j) in item.items"
                :key="'main-menu-mobile-subnav_' + i + '_item_' + j"
                class="nav-item"
                :data-test-id="'main-menu-mobile-subnav_' + i + '_item_' + j"
            >
              <a class="nav-link py-3 d-flex"
                 :class="{ 'active': isCurrentPath(s.path, true), 'disabled': s.disabled }"
                 :href="s.disabled ? undefined : s.path"
                 :aria-disabled="s.disabled || undefined"
              >
                <b-icon v-if="s.icon && s.icon !== 'null'" :icon="s.icon" :alt="s.title" class="me-2" fixed-width />
                <b-icon v-else-if="hasIcons(item)" :icon="'cog'" class="invisible me-2" fixed-width />
                {{ s.title }}
              </a>
            </li>
          </b-collapse>
        </template>
      </ul>
    </div>
  </b-collapse>
</template>

<script setup lang="ts">
import { toRef } from 'vue'
import { MenuItem } from '../defaultMenuItems'
import { useActiveMenu } from '../composables/useActiveMenu'
import { useSharedCollapse } from '../composables/useSharedCollapse'

interface Props {
  menuitems: MenuItem[]
}

const props = defineProps<Props>()

const { activeMenuItem, isCurrentPath, hasIcons } = useActiveMenu(toRef(props, 'menuitems'))

const { showCollapse } = useSharedCollapse('main-menu-flyout')
</script>

<style lang="scss">
@import '../scss/colors';
@import '../scss/transitions';

#main-menu-flyout {
  background: $gray-800;

  .nav-item,
  li.nav-link {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .nav-link:not(.disabled) {
    transition: $transition-base;
    background: $black;
    color: $white;

    &:active,
    &.active {
      border-bottom: 4px solid $primary;
    }

    &:hover {
      background: $white;
      color: $black;
    }
  }

  .subnavigation {
    .nav-link {
      background: $black;

      &.active,
      &:active {
        border-bottom: 4px solid $primary;
      }
    }
  }
}
</style>
